import axios from "axios";
import { api_url, node_api_url, python_api_url } from "../constants/api_constants";

export const axiosInstance = axios.create({
  baseURL: api_url,
});

export const axiosNodeInstance = axios.create({
  baseURL: node_api_url,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json;charset=utf-8"
  }
});

export const axiosPythonInstance = axios.create({
  baseURL: python_api_url,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json;charset=utf-8"
  }
});